import { render, staticRenderFns } from "./url_scheme.vue?vue&type=template&id=5232cbc3"
import script from "./url_scheme.vue?vue&type=script&lang=js"
export * from "./url_scheme.vue?vue&type=script&lang=js"
import style0 from "./url_scheme.vue?vue&type=style&index=0&id=5232cbc3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports